type TokenRef = { current: string | null };
type ClearAuthFn = () => void;

let tokenRef: TokenRef | null = null;
let clearAuthFn: ClearAuthFn | null = null;

export function register(ref: TokenRef, clear: ClearAuthFn): void {
  tokenRef = ref;
  clearAuthFn = clear;
}

export function getToken(): string | null {
  return tokenRef?.current ?? null;
}

export function clearAuth(): void {
  clearAuthFn?.();
}
